import { PathsEnum } from 'pages/Paths'
import { ColorsEnum } from 'types/cssTypes'

export const filterColorMapping: { [key: string]: keyof typeof ColorsEnum } = {
  files: ColorsEnum.info,
}
export const pathSliceViewMapping = {
  files: PathsEnum.fileShareFiles,
}

export const COMMENT_CHAR_LIMIT = 125

export const ROW_MODEL_TYPE = 'serverSide'

export const FILE_SHARE_DEFAULT_FILE_COLUMN = {
  suppressMovable: true,
  sizeColumnsToFit: true,
  autoSizeColumn: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab'],
}

export const fileShareAPI = {
  upload: 'upload',
  download: 'download',
  list: 'list',
  delete: 'delete',
}
